module.exports = __webpack_public_path__ + "static/media/welcome-page-text.502559e9.png";